module.exports = __webpack_public_path__ + "static/media/periodo.7848c358.png";